import React from 'react';
import {makeStyles} from "@material-ui/styles";
import {PageWithoutSidebar} from "../common/PageWithoutSidebar/PageWithoutSidebar";

const useStyles = makeStyles({
    textWhite: {
        color: 'white',
    },

});

const Footer = (props) => {
    const {baseUrl, match} = props

    let year = new Date().getFullYear()

    const classes = useStyles();
    return (<footer className={`d-flex justify-content-center align-items-center ${PageWithoutSidebar.indexOf(match.path) === -1 ? ' ' : 'ps-0'}`}>
            <a target="_blank" rel="noreferrer" className={classes.textWhite} href={baseUrl}>
                © 2017-{year} Edem-v-Gosti.ru
            </a>
        </footer>
    );
}

export default Footer;